import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { WidgetConfigurationSubCard } from '@framework/ui/components/configuration-card/widget/WidgetConfigurationSubCard.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { IconLifebuoy } from '@tabler/icons-react';
import { darken } from 'polished';
import styled from 'styled-components';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput.tsx';

/**
 * Separatore reso sopra la sub-card: in versione dense le sub-card disegnano
 * solo il separatore inferiore (vedi ConfigurationSubCard), quindi dopo campi
 * semplici la linea sopra va aggiunta qui.
 */
const SubCardSeparator = styled.div`
  border-bottom: 1px solid ${props => darken(0.1, props.theme.colorBgLayout)};
  margin-inline: -12px;
  padding-top: 6px;
  margin-bottom: 16px;
`;

export interface ICommonHelpTextsInputConfigSubCardProps {
  /** Nasconde il campo Placeholder (es. widget senza input testuale). */
  hidePlaceholder?: boolean;
  /** Nasconde il campo Testo di aiuto. */
  hideHelpText?: boolean;
  /** Nasconde il separatore sopra la sub-card. */
  hideTopSeparator?: boolean;
}

/**
 * Sub-card "Testi di supporto" nella card Impostazioni generali: Placeholder
 * e Testo di aiuto. Con entrambi i campi nascosti non renderizza nulla.
 * È l'ultimo contenuto della card: l'ultimo campo visibile azzera il margine
 * dell'help per non lasciare spazio in fondo.
 */
export function CommonHelpTextsInputConfigSubCard(
  props: ICommonHelpTextsInputConfigSubCardProps,
) {
  if (props.hidePlaceholder && props.hideHelpText) return null;

  return (
    <>
      {!props.hideTopSeparator && <SubCardSeparator />}
      <WidgetConfigurationSubCard
        icon={<TbIcon icon={IconLifebuoy} />}
        title="Testi di supporto"
        description="Indicazioni facoltative mostrate a chi compila, dentro e sotto il campo."
      >
        {!props.hidePlaceholder && (
          <FormItem
            name="placeholder"
            label="Placeholder"
            // Ultimo campo solo quando il Testo di aiuto è nascosto
            layout={{ removeHelpMargin: props.hideHelpText }}
            help="Testo di esempio mostrato nel campo finché è vuoto; non viene salvato."
          >
            <TextInput name="placeholder" />
          </FormItem>
        )}
        {!props.hideHelpText && (
          <FormItem
            name="helpText"
            label="Testo di aiuto"
            layout={{ removeHelpMargin: true }}
            help={
              <>
                Il <b>Testo di aiuto</b> è mostrato sotto il campo durante la
                compilazione, per dare maggiori indicazioni all&apos;utente.
              </>
            }
          >
            <RichTextAdvancedInput
              name="helpText"
              rows={2}
              menus={MenuPresets.Minimal}
            />
          </FormItem>
        )}
      </WidgetConfigurationSubCard>
    </>
  );
}
